import type { I18nDictionaryShape } from '../../types';
import type { commonEnGb } from '../en-GB/common';

export const commonDeDe = {
  brand: {
    logoAlt: 'Safi-Logo',
    name: 'Safi',
    vatLabel: 'Safi-USt-IdNr.',
  },
  domains: {
    evidence: 'Nachweise',
    evidenceLower: 'nachweise',
    qualityControl: 'Qualitätskontrolle',
    qualityControlLower: 'qualitätskontrolle',
  },
  currencySelectField: {
    groups: {
      other: 'Andere',
      suggested: 'Empfohlen',
    },
  },
} satisfies I18nDictionaryShape<typeof commonEnGb>;
